module.exports = __webpack_public_path__ + "static/media/PATS_5-1363w.c746236f.png";